module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_photogenic-08582225e37adcaa974780d309cb3801.webp";